/** Drop zone of the pivot field panel. */
export enum PivotZoneEnum {
  Rows = 'Rows',
  Columns = 'Columns',
  Measures = 'Measures',
  Filters = 'Filters',
}
